import React from 'react';

import airduct from '../assets/airduct.jpg';
import heating from '../assets/heating.png';
import maintenance from '../assets/maintenance.jpg';
import ac from '../assets/ac.webp';
import airqual from '../assets/airqual.jpg';
import handyman from '../assets/handyman-shh.png';
import extra from '../assets/additional-shh.webp';
import { HashLink } from 'react-router-hash-link';

const MiniServices = () => {
  return (
    <div>
      <div className="flex justify-center items-center pt-10">
        <hr className="w-[15%] mx-8 border-1 border-black" />
        <p className="text-4xl md:text-5xl text-center font-bold" id="Services">
          Our <span className="text-blue-600">Services</span>
        </p>
        <hr className="w-[15%] mx-8 border-1 border-black" />
      </div>
      <p className="text-center pt-6 pb-10 mx-8 md:mx-auto">
        Optimal Temp Cooling & Heating is an award-winning HVAC contractor.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-20 justify-center items-start md:px-14 pb-20 gap-12">
        <div className="mx-20 md:mx-auto">
          <img
            className="w-full md:h-80 rounded-sm object-cover"
            src={ac}
            alt="kitchen renovation"
          />
          <p className="font-medium text-2xl my-4">Air Conditioning</p>
          <p>
            Beat the Florida heat with fast, reliable air conditioning service
            you can trust. We diagnose cooling issues quickly and provide honest
            solutions that fit your home and budget. Count on Optimal Temp HVAC
            to keep your home cool and comfortable all year long.
          </p>
          <HashLink to="/#Contact">
            <button className="bg-[#FD6721] text-white rounded-sm shadow-sm shadow-black px-3 py-1 hover:bg-blue-600 mt-6 self-end">
              Learn More
            </button>
          </HashLink>
        </div>
        <div className="mx-20 md:mx-auto">
          <img
            className="w-full md:h-80 rounded-sm object-cover"
            src={maintenance}
            alt="bathroom renovation"
          />
          <p className="font-medium text-2xl my-4">Preventative Maintenance</p>
          <p>
            Regular maintenance helps your system run efficiently and prevents
            costly breakdowns. Our comprehensive tune-ups are designed to extend
            the life of your equipment and improve performance. With Optimal
            Temp HVAC, you get peace of mind knowing your system is ready for
            any season.
          </p>
          <HashLink to="/#Contact">
            <button className="bg-[#FD6721] text-white rounded-sm shadow-sm shadow-black px-3 py-1 hover:bg-blue-600 mt-6 self-end">
              Learn More
            </button>
          </HashLink>
        </div>
        <div className="mx-20 md:mx-auto">
          <img
            className="w-full md:h-80 rounded-sm object-cover"
            src={heating}
            alt="flooring install"
          />
          <p className="font-medium text-2xl my-4">Heating</p>
          <p>
            Stay warm and comfortable when temperatures drop with dependable
            heating service. We repair, replace, and maintain all major heating
            systems to keep them running safely and efficiently. Optimal Temp
            HVAC ensures your home stays cozy even during unexpected cold
            spells.
          </p>
          <HashLink to="/#Contact">
            <button className="bg-[#FD6721] text-white rounded-sm shadow-sm shadow-black px-3 py-1 hover:bg-blue-600 mt-6 self-end">
              Learn More
            </button>
          </HashLink>
        </div>
        <div className="mx-20 md:mx-auto">
          <img
            className="w-full md:h-80 rounded-sm object-cover"
            src={airduct}
            alt="painting service"
          />
          <p className="font-medium text-2xl my-4">Air Duct Repair</p>
          <p>
            Damaged or leaking ductwork can cause uneven temperatures and higher
            energy bills. We identify problem areas and restore your duct system
            so air flows cleanly and efficiently. Trust Optimal Temp HVAC to
            improve your comfort and your system’s performance.
          </p>
          <HashLink to="/#Contact">
            <button className="bg-[#FD6721] text-white rounded-sm shadow-sm shadow-black px-3 py-1 hover:bg-blue-600 mt-6 self-end">
              Learn More
            </button>
          </HashLink>
        </div>
        <div className="mx-20 md:mx-auto">
          <img
            className="w-full md:h-80 rounded-sm object-cover"
            src={airqual}
            alt="handyman service"
          />
          <p className="font-medium text-2xl my-4">Indoor Air Quality</p>
          <p>
            Cleaner air starts with the right indoor air quality solutions
            tailored to your home. We offer filtration, purification, and
            ventilation options that reduce allergens and pollutants. Breathe
            easier with Optimal Temp HVAC and create a healthier home
            environment.
          </p>
          <HashLink to="/#Contact">
            <button className="bg-[#FD6721] text-white rounded-sm shadow-sm shadow-black px-3 py-1 hover:bg-blue-600 mt-6 self-end">
              Learn More
            </button>
          </HashLink>
        </div>
        <div className="mx-20 md:mx-auto">
          <img
            className="w-full md:h-80 rounded-sm object-cover"
            src={extra}
            alt="additional services"
          />
          <p className="font-medium text-2xl my-4">AC Installation</p>
          <p>
            Whether you’re upgrading or installing a new system, we help you
            choose the right unit for your home. Our expert installations
            maximize efficiency, improve comfort, and reduce energy costs. With
            Optimal Temp HVAC, you get a system built to perform for years.
          </p>
          <HashLink to="/#Contact">
            <button className="bg-[#FD6721] text-white rounded-sm shadow-sm shadow-black px-3 py-1 hover:bg-blue-600 mt-6 self-end">
              Learn More
            </button>
          </HashLink>
        </div>
      </div>
    </div>
  );
};

export default MiniServices;
